<ce-layout-footer-container class="CtepFooter-container">
    <div class="CtepFooter-content flex-center u-spacing-3xl-pb u-text-body-sm">
        <p class="CtepFooter-content-powered u-color-text-secondary">Powered by Kempower ChargEye</p>
    </div>
</ce-layout-footer-container>
